// extracted by mini-css-extract-plugin
export default {"container":"list_container__Gj6kk","search":"list_search__3wskU"};